import { Controller } from "@hotwired/stimulus";
import Vue from "vue/dist/vue.esm";
import App from "../components/WidgetToggler.vue";

export default class extends Controller {
  connect() {
    const el = this.element;

    this.vueInstance = new Vue({
      el,
      render: h => h(App, {
        props: {
          name: el.dataset.name,
          size: el.dataset.size,
        }
      })
    });
  }

  handleSizeUpdate(event) {
    const newSize = event.detail.size.toString();
    
    // Update the dataset
    this.element.dataset.size = newSize;
    
    // Recreate the Vue instance with the new size
    if (this.vueInstance) {
      this.vueInstance.$destroy();
    }
    
    this.vueInstance = new Vue({
      el: this.element,
      render: h => h(App, {
        props: {
          name: this.element.dataset.name,
          size: newSize,
        }
      })
    });
  }
}
